export default "<ion-content>\r\n  <!-- Blank Component -->\r\n</ion-content>";